import { getEnabledEvents } from './utils'

import { registerGtmSubscribers } from './subscribers/gtm'
import { registerInternalSubscribers } from './subscribers/internal'
import { registerWebengageSubscribers } from './subscribers/webengage'

import { ValidatedScripts } from '../third-party-scripts/response-data-validator'

let hasBootstrapped = false

export function bootstrapEventSubscribers(thirdPartyScriptData: ValidatedScripts) {
    if (hasBootstrapped) return

    if (thirdPartyScriptData.webengage?.enabled) {
        const webengageEnabledEvents = getEnabledEvents(thirdPartyScriptData.webengage.events)
        registerWebengageSubscribers(webengageEnabledEvents)
    }

    if (thirdPartyScriptData.gtm?.enabled) {
        const gtmEnabledEvents = getEnabledEvents(thirdPartyScriptData.gtm.events)
        registerGtmSubscribers(gtmEnabledEvents)
    }

    if (thirdPartyScriptData.internal?.enabled) {
        const internalEnabledEvents = getEnabledEvents(thirdPartyScriptData.internal.events)
        registerInternalSubscribers(internalEnabledEvents)
    }

    hasBootstrapped = true
}
